import React, { FC } from 'react';

import { Checkbox, Popover } from '@material-ui/core';

import { IAdminGroup } from '../../../../store/admin/groups/store';
import { IAdminMembership } from '../../../../store/admin/memberships/store';

import { userPic, TagSelected, TagOutline, PlayerOutline } from '../../../../assets/images';
import Button from '../../../../components/Button';
import { toHandicap } from '../../../../contrib/Utils/toHandicap';

interface IProps {
  item: IAdminMembership;
  context?: any;
}

export const PlayerRenderer: FC<IProps> = props => {
  const {
    item,
    item: {
      user: {
        profile: { image, ghinNumber, handicapCurrent },
        firstName,
        lastName,
        email
      },
      groups,
      id,
      club
    },
    context: {
      onChangeTag,
      goToPlayerProfile,
      groupEdition,
      handleMenu,
      currentTagMenuId,
      tagMenuIsOpen,
      anchorEl,
      handleClose,
      mobileVersion
    }
  } = props;

  const playerGroups = groups.map((group: IAdminGroup) => group.id);

  return (
    <div className="player-row">
      <div className="player-item firstname">
        <img
          id="edit-picture"
          className="user-pic"
          src={image || userPic}
          alt={(firstName || email) + ' avatar'}
        />

        <span>{firstName || email}</span>
      </div>

      <div className="player-item lastname">{lastName || ''}</div>

      {!mobileVersion && (
        <>
          <div className="player-item ghin">{ghinNumber || '-'}</div>
          <div className="player-item index">{toHandicap(handicapCurrent || 0)}</div>
          {!!groupEdition && (
            <div className="player-item">
              <Button onClick={handleMenu(id)}>
                <img
                  src={currentTagMenuId === id && !!tagMenuIsOpen ? TagSelected : TagOutline}
                  className="player-item-icon tag-outline"
                  alt="logo"
                />
              </Button>

              {currentTagMenuId === id && !!tagMenuIsOpen && (
                <Popover
                  className="individual-group-selection staff-scope"
                  classes={{
                    paper: 'group-selection__paper override'
                  }}
                  id="popper"
                  open={tagMenuIsOpen}
                  anchorEl={anchorEl}
                  onClose={handleClose}
                  anchorOrigin={{
                    horizontal: 'right',
                    vertical: 'bottom'
                  }}
                  transformOrigin={{
                    horizontal: 'right',
                    vertical: 'top'
                  }}
                >
                  <div className="tags-title">TAG PLAYER</div>

                  {groups.map((group: IAdminGroup) => (
                    <div key={group.id} className="checkbox-container">
                      <Checkbox
                        className="tag-player-check"
                        checked={playerGroups.includes(group.id)}
                        onChange={onChangeTag(playerGroups, group.id, item)}
                        color="primary"
                      />

                      <p>{group.name}</p>
                    </div>
                  ))}
                </Popover>
              )}

              <Button onClick={goToPlayerProfile(club, id)}>
                <img src={PlayerOutline} className="player-item-icon player-outline" alt="logo" />
              </Button>
            </div>
          )}
        </>
      )}
    </div>
  );
};
